const firebaseConfig = {
    apiKey: "AIzaSyCZAMuHZwQjaUD-hn2LwD-1Ycr_ErOeJm4",
    authDomain: "digie-ir.firebaseapp.com",
    projectId: "digie-ir",
    storageBucket: "digie-ir.appspot.com",
    messagingSenderId: "235994789484",
    appId: "1:235994789484:web:3eee600c2048f9dadd0a49"
  };

  export default firebaseConfig;